<template>
    <RouterView/>
</template>

<script>
export default {
name: "TournamentIndex"
}
</script>

<style scoped>

</style>
